module.exports = __webpack_public_path__ + "static/media/dot_loader.2fb6e0a7.gif";